/**
 * Compact, locale-aware date string for table cells / detail fields.
 *
 * Shared home for the directory screens (venues, properties, …). `null`
 * / invalid ISO → empty string so one bad row never breaks the layout —
 * the caller renders a placeholder (`"—"`).
 *
 * `locale` should be the active i18next language (`i18n.language`) so the
 * formatting follows the operator's chosen locale, not the browser's.
 * Falls back to the runtime default when omitted.
 */
export function formatDateShort(value: string | null | undefined, locale?: string): string {
  if (!value) return "";
  const ms = Date.parse(value);
  if (Number.isNaN(ms)) return "";
  return new Date(ms).toLocaleDateString(locale || undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
}
